import { Environment } from '@abp/ng.core';

const baseUrl = 'https://dev-front.fleetlabs.link/';

const oAuthConfig = {
  issuer: 'https://dev-auth.fleetlabs.link/',
  redirectUri: baseUrl,
  clientId: 'cargo_fleet_App',
  dummyClientSecret: '',
  scope: 'offline_access cargo_fleet',
  strictDiscoveryDocumentValidation: false,
  IsSelfRegistrationEnabled: false,
  // "Entrar neste tenant" nativo (host, permissão Saas.Tenants.Impersonation).
  // userImpersonation fica DESLIGADA de propósito.
  impersonation: { tenantImpersonation: true }
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'cargo_fleet',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://dev-api.fleetlabs.link/',
      rootNamespace: 'cargo_fleet',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  firebaseConfig: {

    apiKey: "AIzaSyCUPqDDby_f8QJVsi63DiPiksz9bLa5gmk",
    authDomain: "cargofleet-vbl.firebaseapp.com",
    projectId: "cargofleet-vbl",
    storageBucket: "cargofleet-vbl.firebasestorage.app",
    messagingSenderId: "683550175684",
    appId: "1:683550175684:web:02aea4967e63304ef4b491",
    measurementId: "G-FFQVTGWCEG"
  },
  vapidKey: "BLYaeP8Vc5lfHbtxmElAaiWeuMeSrLFcg84L38jztI17Idh-cEQ6iRVmdqtUoBGuHMAK_rNjDVHvctFO5dRDEdE"
} as Environment;
